import ImageComparisonSpace from './ImageComparisonSpace'

export default ImageComparisonSpace
